import fetch from 'node-fetch';
import {
  RequestType,
  IExternalRequester,
  KameleoonResponseType,
  SendRequestParametersType,
} from '@kameleoon/nodejs-sdk';

export class KameleoonRequester implements IExternalRequester {
  public async sendRequest({
    url,
    parameters,
  }: SendRequestParametersType<RequestType>): Promise<KameleoonResponseType> {
    return await fetch(url, parameters);
  }

  get isKameleoonRequester(): boolean {
    return true;
  }
}
